import DOMPurify from "dompurify";

/**
 * Sanitize HTML strings coming from the CMS before passing to
 * `dangerouslySetInnerHTML`. Prevents stored XSS by stripping
 * script tags, event handlers, javascript: URLs, etc.
 */
export function safeHtml(raw: string | null | undefined): string {
  if (!raw) return "";
  return DOMPurify.sanitize(raw, { USE_PROFILES: { html: true } });
}
